import PropTypes from "prop-types";
// form
import { Controller, useFormContext } from "react-hook-form";
// @mui
import InputAdornment from "@mui/material/InputAdornment";
// components
import TextField from "src/components/template/text-field";

// ----------------------------------------------------------------------

const regex = /^items\[\d+]\.value\[\d+]\.item_quantity$/;

export default function RHFTextField({ name, helperText, type, onTextChange, unit, trim, enableChinese, ...other }) {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <TextField
                    {...field}
                    type={type}
                    InputProps={{
                        ...( type === "number" && {
                            onKeyDown: (e) => {
                                if (["e", "E"].includes(e.key)) {
                                    e.preventDefault();
                                }
                            }
                        } ),
                        startAdornment: unit ? (
                            <InputAdornment position="start" sx={{ "& .MuiTypography-root": { color: "text.tertiary" } }}>{unit}</InputAdornment>
                        ) : null
                    }}
                    value={field.value ?? ""}
                    // value={type === 'number' && field.value === 0 ? '' : ( field?.value ?? '' )}
                    onChange={(event) => {
                        if (type === "number2digit") {
                            // Get the current value of the input
                            let _value = event.target.value;

                            // Regular expression to allow numbers and limit to 4 decimal places
                            _value = _value.replace(/[^0-9.]/g, ""); // Remove non-numeric and non-decimal point characters

                            // Split the value into the integer and decimal parts
                            const parts = _value.split(".");

                            // If there's a decimal part, limit it to 4 digits
                            if (parts[1]) {
                                parts[1] = parts[1].slice(0, 2); // Limit decimal part to 4 digits
                            }

                            // Join the integer and decimal parts back together
                            _value = parts.join(".");

                            field.onChange(_value);
                        } else if (type === "phone") {
                            let _value = event.target.value;

                            // only keep number
                            _value = _value.replace(/\D/g, "");

                            // 根据数字长度动态格式化
                            if (_value.length > 0) {
                                if (_value.length <= 3) {
                                    _value = `${_value}`;
                                } else if (_value.length <= 7) {
                                    _value = `${_value.slice(0, 3)}-${_value.slice(3)}`;
                                } else if (_value.length <= 10) {
                                    _value = `(${_value.slice(0, 3)}) ${_value.slice(3, 6)}-${_value.slice(6)}`;
                                }
                            }

                            field.onChange(_value);
                        } else if (type === "promo") {
                            let _value = event.target.value;

                            _value = _value.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();

                            field.onChange(_value);
                        } else {
                            const _value = enableChinese ? event.target.value : event.target.value.replace(/[^a-zA-Z0-9À-ÖØ-ÿ\s\p{P}\\s]/gu, "");

                            if (trim) {
                                _value.trim();
                            }

                            field.onChange(_value);
                            // field.onChange(event.target.value);

                            if (onTextChange) {
                                onTextChange({
                                    name,
                                    value: event.target.value
                                });
                            }
                        }
                    }}

                    {...( type === "number" && {
                        inputMode: "decimal"
                    } )}

                    {...( type === "number" && regex.test(name) && {
                        onFocus: (event) => {
                            if (event.target.value === "0") {
                                field.onChange("");
                            }
                        },
                        onBlur: (event) => {
                            if (event.target.value.trim() === "") {
                                field.onChange(0);
                            }
                            field.onBlur();
                        }
                    } )}

                    error={!!error}
                    helperText={error ? error?.message : helperText}
                    {...other}
                />
            )}
        />
    );
}

RHFTextField.propTypes = {
    helperText: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string,
    onTextChange: PropTypes.func,
    unit: PropTypes.node,
    trim: PropTypes.bool,
    enableChinese: PropTypes.bool
};
